import{Outlet} from 'react-router-dom'

export default function ProductsPage() {
  return (
    <div> 
      <Outlet/>
    </div>
  );
}